import React from 'react'
import Icon from 'material-ui/Icon'

const HistoryNav = props => {
  const { data, active, info, expandInfo } = props

  const { historyName, activeName } = info

  return (
    <div style={{ display: 'flex', float: 'right' }}>
      {data &&
        data.length > 1 && (
          <div>
            {active > 0 ? (
              <Icon
                onClick={() => info.action(historyName, activeName, active - 1)}
              >
                chevron_left
              </Icon>
            ) : (
              <Icon style={{ color: '#ccc' }}>chevron_left</Icon>
            )}
            {active < data.length - 1 ? (
              <Icon
                onClick={() => info.action(historyName, activeName, active + 1)}
              >
                chevron_right
              </Icon>
            ) : (
              <Icon style={{ color: '#ccc' }}>chevron_right</Icon>
            )}
            {/* <Icon
              onClick={() => {
                expandInfo()
                info.action(null)
              }}
            >
              close
            </Icon> */}
          </div>
        )}
      <div>
        <Icon
          onClick={() => {
            expandInfo()
            info.action(historyName, activeName, null)
          }}
        >
          close
        </Icon>
      </div>
    </div>
  )
}

export default HistoryNav



// WEBPACK FOOTER //
// ./src/common/components/HistoryNav.js